import { Spinner } from 'react-bootstrap';
import { BackButton } from 'Components/molecules';
import { AgentDetailContent } from 'Components/organisms';
import { Typography } from 'Components/atoms';
import { useAgentManagementPreview } from 'Hooks/useAgentManagementPreview';
import { AGENTS_DASHBOARD_ROUTE } from 'Core-utils/routes';
import './styles.scss';

/**
 * Agent Detail page (APD-1867).
 *
 * Accessible at /agents/:id — navigated to from the Agent Inventory at
 * /dashboard/agents. Feature-gated behind the
 * `securityhub.agentmanagement.preview.enabled` tenant setting.
 */
const AgentDetailPage = () => {
    const { isLoading, isEnabled } = useAgentManagementPreview();

    const renderBody = () => {
        if (isLoading) {
            return (
                <div className="d-flex justify-content-center align-items-center agent-detail-page__loading">
                    <Spinner animation="border" />
                </div>
            );
        }

        if (!isEnabled) {
            return (
                <div className="bg-text-black p-4 card">
                    <Typography variant="subtitle2" color="text-high-emphasis">
                        Agent Management
                    </Typography>
                    <Typography variant="body3" color="text-medium-emphasis" className="mt-2">
                        Agent Management is a preview feature. Contact your administrator to enable it for this tenant.
                    </Typography>
                </div>
            );
        }

        return <AgentDetailContent />;
    };

    return (
        <div className="user-specific-page">
            <div className="user-specific-page__content d-flex flex-column gap-3 h-100">
                <BackButton navigateBack={AGENTS_DASHBOARD_ROUTE} />
                {renderBody()}
            </div>
        </div>
    );
};

export default AgentDetailPage;
